export const environment = {
	production: false,
	api: 'https://dev-api.brainssoftware-apps.nl',
	imagesHost: 'https://brainssoftware-apps.nl',
	recaptchaSiteKey: '6Lfo3b8qAAAAALGt0fQ-z_HWX7lB0QhsBLvOQhex',
};

// http://localhost:3000 --> Local dev testing.
// https://dev-api.brainssoftware-apps.nl --> Dev api on server.
